/**
 * Public ids for prompt blocks: what a "scan to copy" QR points at.
 *
 * The first 16 hex of sha256("stage-prompt-v1", slug, slide id, block index),
 * NUL-joined. It names one prompt block and exposes nothing else (not the slug,
 * the slide id, or how many there are), and it is stable across republishing
 * while the slide keeps its id. Mirrors backend/app/deck/prompt_ids.py;
 * contracts/prompt-ids.cases.json holds the answers both must give.
 *
 * Async because it uses Web Crypto. Where that is missing (an insecure origin),
 * it resolves to null and the QR control simply is not offered.
 */
export const PROMPT_ID_PREFIX = "stage-prompt-v1";

export async function promptId(slug: string, slideId: string, index: number): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) return null;
  const raw = new TextEncoder().encode([PROMPT_ID_PREFIX, slug, slideId, String(index)].join("\0"));
  const digest = new Uint8Array(await subtle.digest("SHA-256", raw));
  return [...digest.slice(0, 8)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

/** A prompt whose whole text is one http(s) link is a link, not a command. */
export function isUrlPrompt(text: string): boolean {
  return /^https?:\/\/\S+$/.test(text.trim());
}
